

export default function reducer() {
  return `${ EDITOR_VERSION }`;
}
